import { User } from "./user";

export class Task {
    public date: Date = new Date();
    public user: User = new User();
    public time: String = "";
    public tasks: string[] = [];
}